import React, { useContext, useState } from 'react';
import Swal from 'sweetalert2';
import { AuthContext } from '../contexts/auth';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

const ChangePasswordForm = ({ updateFunction }) => {
  const { profile, token } = useContext(AuthContext);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmNewPasswordVisible, setConfirmNewPasswordVisible] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (newPassword.length < 6) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'La nuova password deve contenere almeno 6 caratteri!',
      });
      return;
    }

    if (newPassword !== confirmNewPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Le password non coincidono!',
      });
      return;
    }

    updateFunction(token, {
      current_password: oldPassword,
      new_password: newPassword,
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Password cambiata con successo!',
          showConfirmButton: false,
          timer: 1500,
        });
  
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err.response?.data?.message || 'Errore durante il cambio password!',
        });
      });
  };

  return (
    <form onSubmit={handleFormSubmit} className="w-full mx-auto mt-4">
      <div className="mb-4 relative">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="old-password">
          Vecchia Password
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="old-password"
          type={oldPasswordVisible ? 'text' : 'password'}
          placeholder="Vecchia Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
        <span
          className="absolute right-3 top-2/3 transform -translate-y-1/2 cursor-pointer"
          onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
        >
          {oldPasswordVisible ? <EyeSlashIcon className="h-5 w-5 text-gray-500" /> : <EyeIcon className="h-5 w-5 text-gray-500" />}
        </span>
      </div>
      <div className="mb-4 relative">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="new-password">
          Nuova Password
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="new-password"
          type={newPasswordVisible ? 'text' : 'password'}
          placeholder="Nuova Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <span
          className="absolute right-3 top-2/3 transform -translate-y-1/2 cursor-pointer"
          onClick={() => setNewPasswordVisible(!newPasswordVisible)}
        >
          {newPasswordVisible ? <EyeSlashIcon className="h-5 w-5 text-gray-500" /> : <EyeIcon className="h-5 w-5 text-gray-500" />}
        </span>
      </div>
      <div className="mb-6 relative">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="confirm-new-password">
          Conferma Nuova Password
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="confirm-new-password"
          type={confirmNewPasswordVisible ? 'text' : 'password'}
          placeholder="Conferma Nuova Password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
        <span
          className="absolute right-3 top-2/3 transform -translate-y-1/2 cursor-pointer"
          onClick={() => setConfirmNewPasswordVisible(!confirmNewPasswordVisible)}
        >
          {confirmNewPasswordVisible ? <EyeSlashIcon className="h-5 w-5 text-gray-500" /> : <EyeIcon className="h-5 w-5 text-gray-500" />}
        </span>
      </div>
      <div className="flex items-center justify-between">
        <button className="w-100 bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
          Cambia Password
        </button>
      </div>
    </form>
  );
};

export default ChangePasswordForm;
